import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { type DataWarehouseRefFragment } from '@spotify/confidence-graphql';

import { getWarehouseTypeLabel } from './getWarehouseTypeLabel';

export const getWarehouseIdentifier = (
  config: DataWarehouseRefFragment['config'],
): string | undefined =>
  config.bigQueryConfig?.gcpProjectId ??
  config.dataBricksConfig?.host ??
  config.snowflakeConfig?.account ??
  config.redshiftConfig?.cluster ??
  undefined;

export const formatWarehouseName = (
  warehouse: DataWarehouseRefFragment,
  options?: { identifierFirst?: boolean },
): string => {
  const typeLabel = getWarehouseTypeLabel(warehouse.config);
  const identifier =
    getWarehouseIdentifier(warehouse.config) ??
    extractLastNameComponent(warehouse.name);

  if (!identifier) return typeLabel;

  return options?.identifierFirst
    ? `${identifier} (${typeLabel})`
    : `${typeLabel} (${identifier})`;
};
